import React, { Component } from 'react';
import SearchBar from './SeachBar';
import { Box, Button } from '@material-ui/core';

class SearchBarAction extends Component {
    state = { }
    render() {
        return (
            <Box p={1} style={{ display: "flex", justifyContent: "space-between", alignItems:"center"}}>
                {/* actionDisabled / actionTitle sont additifs : absents, le bouton
                    reste actif et sans infobulle, comportement historique de tous
                    les écrans qui utilisent ce composant. Le title est porté par le
                    conteneur, un bouton désactivé ne le rend pas lui-même. */}
                <Box title={this.props.actionTitle || undefined}>
                    <Button
                        onClick={this.props.action}
                        color="primary"
                        variant="contained"
                        disabled={this.props.actionDisabled === true}
                    >
                        Nouveau
                    </Button>
                </Box>
                <Box style={{width: '100%'}}>
                    <SearchBar {...this.props} />
                </Box>
            </Box>
        );
    }
}

export default SearchBarAction;